import { useMutation, useQuery } from '@apollo/client';
import { isEqual } from 'lodash';
import React from 'react';
import { useTranslation } from '@corti/i18n';
import { coreStore } from 'browser/stores';
import { useAuth } from 'core/auth/browser';
import { Autocomplete, MenuItem, TextField } from 'lib/cortiUI';
import { detectionTypesQuery, hideDetectionTypesMutation, } from './graphql';
export const HideDetectionType = () => {
    var _a;
    const { organization } = useAuth();
    const { t } = useTranslation();
    const { data: getDetectionTypesData, loading: isGetDetectionTypesLoading } = useQuery(detectionTypesQuery, {
        variables: {
            organizationID: organization.id,
        },
    });
    const [hideDetectionTypes, { loading: isHideDetectionTypesLoading }] = useMutation(hideDetectionTypesMutation);
    const detectionTypes = (_a = getDetectionTypesData === null || getDetectionTypesData === void 0 ? void 0 : getDetectionTypesData.detectionTypes) !== null && _a !== void 0 ? _a : [];
    const hiddenDetectionTypes = detectionTypes.filter((it) => it.hidden);
    async function handleHiddenAnnotationTypesChange(detectionTypes) {
        await hideDetectionTypes({
            variables: {
                organizationID: organization.id,
                names: detectionTypes.map((it) => it.name),
            },
            refetchQueries: [
                {
                    query: detectionTypesQuery,
                    variables: {
                        organizationID: organization.id,
                    },
                },
            ],
        });
        coreStore.notifications.showNotification({
            type: 'success',
            message: t('adminPanel:status.successfullyUpdated', 'Successfully updated'),
        });
    }
    return (React.createElement(Autocomplete, { multiple: true, disableCloseOnSelect: true, disabled: isGetDetectionTypesLoading || isHideDetectionTypesLoading, options: detectionTypes, getOptionLabel: (option) => option.name, value: hiddenDetectionTypes, isOptionEqualToValue: (option, value) => isEqual(option, value), onChange: (_, nextValues) => {
            void handleHiddenAnnotationTypesChange(nextValues);
        }, renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { label: t('adminPanel:orgDataManagement.hiddenDetectionTypes', 'Hidden detection types') }))), renderOption: (props, option, state) => (React.createElement(MenuItem, Object.assign({}, props, { selected: state.selected, key: option.name }), option.name)), ChipProps: {
            size: 'small',
        } }));
};
